import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web/slate/Button";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { useEditSettingsLink } from "../../hooks/useEditSettingsLink";
export var PhoneNumberErrorMessage = function PhoneNumberErrorMessage() {
  return /*#__PURE__*/React.createElement(Typography, {
    color: Core.text.critical,
    variant: "labelSansRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "hV1GDT",
    defaultMessage: [{
      "type": 0,
      "value": "Ajoutez un numéro de téléphone dans les "
    }, {
      "children": [{
        "type": 0,
        "value": "paramètres de votre compte"
      }],
      "type": 8,
      "value": "LinkFormatting"
    }],
    values: {
      LinkFormatting: LinkToAccountSetting
    }
  }));
};
var LinkToAccountSetting = function LinkToAccountSetting(chunks) {
  var editSettingsLink = useEditSettingsLink();
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: editSettingsLink,
    style: {
      color: Core.text.critical,
      textDecorationColor: Core.text.critical,
      fontSize: "inherit"
    },
    target: "_blank"
  }, chunks);
};